import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p>
        At UpDeals, accessible from https://updeals.in, one of our main priorities is the privacy of our visitors.
        This Privacy Policy document outlines the types of information collected and how we use it.
      </p>
      <p>
        <strong>Information We Collect:</strong> We do not require account registration or store sensitive personal data.
        Standard anonymous analytics (page views, browser types, timestamps) may be processed to optimize the user experience.
      </p>
      <p>
        <strong>Affiliate Links & Cookies:</strong> UpDeals contains affiliate links. When you click on an external link to
        retailers such as Amazon, Flipkart, or Myntra, third-party cookies may be set by those stores to credit referrals.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
